import { render, staticRenderFns } from "./AktarView.vue?vue&type=template&id=5aacc8fe&scoped=true"
import script from "./AktarView.vue?vue&type=script&lang=ts"
export * from "./AktarView.vue?vue&type=script&lang=ts"
import style0 from "./AktarView.vue?vue&type=style&index=0&id=5aacc8fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aacc8fe",
  null
  
)

export default component.exports